import { Injectable } from '@angular/core';

import { TARGET_RATES_APP_STATE_SLICE_KEY } from 'TargetRatesApp/apps/target-rates-app/state/constants';

import { AppStateService } from 'Angular/services/app-state.service';

@Injectable({
    providedIn: 'root',
})
export class TargetRatesAppStateService {
    constructor(private appStateService: AppStateService) {}

    initAppState(): void {
        this.appStateService.setStateSlice(TARGET_RATES_APP_STATE_SLICE_KEY);
        this.appStateService.start();
    }

    resetToSystemDefault(): void {
        this.appStateService.resetToSystemDefaultState();
    }
}
